// extracted by mini-css-extract-plugin
export default {"container":"Cartridge_container__8BGGf","cartridge":"Cartridge_cartridge__9JE5v","image":"Cartridge_image__0HdkA","overlay":"Cartridge_overlay__CRSes"};